import Popup from "./Popup";
import React, {useState} from "react";

const Need = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    const togglePopup = (message) => {
        setPopupMessage(message)
        setIsPopupOpen(!isPopupOpen);
    };

    return (
        <>
            {isPopupOpen && <Popup message={popupMessage} onClose={togglePopup}/>}
            <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center md:tw-gap-6 tw-self-stretch">
                <div style={{cursor: "pointer"}} onClick={() => togglePopup(3)} className="tw-flex tw-items-center tw-gap-2">
                    <div className="rc-slider-handle-1"></div>
                    <div className="tw-flex tw-items-center tw-mb-3  tw-gap-1">
                        <span className="tw-text-body-small">Contrat obligatoire</span>
                        <img  src="/o/mutelios-theme-css/icons/QuestionBlack.svg" alt=""/>
                    </div>
                </div>
                <div style={{cursor: "pointer"}} onClick={() => togglePopup(4)} className="tw-flex tw-items-center tw-gap-2">
                    <div className="rc-slider-handle-2"></div>
                    <div className="tw-flex tw-items-center tw-mb-3  tw-gap-1">
                        <span className="tw-text-body-small">Renfort facultatif</span>
                        <img src="/o/mutelios-theme-css/icons/QuestionBlack.svg" alt=""/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Need;
